<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layout-header></layout-header>
    <layout-sidebar></layout-sidebar>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <!-- Page Header -->
        <div class="page-header">
          <div class="content-invoice-header">
            <h5>
              <router-link to="/invoices" style="color: #28084b">
                <i class="feather feather-arrow-left me-1"></i> </router-link
              >Invoice Details
            </h5>
            <div class="list-btn">
              <ul class="filter-list">
                <li>
                  <a
                    @click="openModal(invoice, 'download')"
                    class="btn-filters w-auto"
                    ><i class="fa fa-download" aria-hidden="true"></i
                  ></a>
                </li>
                <li>
                  <router-link
                    :to="`/` + invoice.code "
                    class="btn btn-outline-primary"
                    ><i class="fa fa-eye me-2" aria-hidden="true"></i>View as
                    customer</router-link
                  >
                </li>
                <li>
                  <div class="btn-group">
                    <button
                      type="button"
                      class="btn btn-primary dropdown-toggle me-1"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Action
                    </button>
                    <div class="dropdown-menu">
                      <router-link
                        class="dropdown-item"
                        :to="`/edit-invoice/` + $route.params.id"
                        ><i class="far fa-edit me-2"></i>Edit</router-link
                      >
                      <a
                        class="dropdown-item"
                        @click="openModal(invoice, 'send')"
                        ><i class="fa fa-bolt text-success me-2"></i
                        >{{
													invoice.status === "partially_paid" ||
													invoice.status === "sent"
														? "Resend"
														: "Send"
                        }}</a
                      >
                      <a
                        class="dropdown-item"
                        @click="openModal(invoice, 'delete')"
                        ><i class="far fa-trash-alt text-danger me-2"></i
                        >Delete</a
                      >
                      <a
                        class="dropdown-item"
                        @click="openModal(invoice, 'duplicate')"
                        ><i class="far fa-clone me-2"></i>Duplicate</a
                      >
                      <a
                        v-if="
													invoice.status == 'sent' ||
													invoice.status == 'viewed' ||
													invoice.status == 'draft'
												"
                        class="dropdown-item"
                        @click="openModal(invoice, 'refund')"
                        ><i class="fa fa-undo me-2"></i>Mark as refunded</a
                      >
                      <a
                        class="dropdown-item"
                        @click="openPaymentModal(invoice)"
                        ><i class="fa fa-credit-card me-2"></i>Record Payment</a
                      >
                      <a
                        v-if="invoice.status !== 'draft'"
                        class="dropdown-item"
                        @click="openModal(invoice, 'send-reminder')"
                        ><i class="fa fa-bolt text-success me-2"></i>Send
                        Reminder</a
                      >
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <!-- /Page Header -->
        <div class="row justify-content-center" v-if="invoice">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="card-table">
                  <!-- For mobile -->
                  <mobileinvoiceview
                    :invoice="invoice"
                    :user="user"
                    :settings="settings"
                    :totalProductDiscount="totalProductDiscount"
                    :preferred_bank="preferred_bank"
                    :vat="vat"
                  />

                  <!-- For Desktop -->
                  <div class="card-body d-invoice" id="invoice">
                    <!-- Invoice Logo -->
                    <div class="invoice-item invoice-item-one">
                      <div class="invoice-header align-items-center">
                        <div class="col-md-4 col-lg-4">
                          <div
                            v-if="settings.business_logo"
                            class="invoice-logo"
                          >
                            <img :src="settings.business_logo" alt="logo" />
                          </div>
                          <router-link
                            v-else
                            class="btn btn-primary upload-logo"
                            to="/invoice/settings"
                            ><i
                              class="feather feather-upload me-2"
                              aria-hidden="true"
                            ></i
                            >Upload Business logo</router-link
                          >
                        </div>
                        <div class="descrip col-md-6 col-lg-4">
                          <div class="invoice-info">
                            <h1 class="invoice-head mb-2">
                              {{ invoice?.invoice_id }}
                            </h1>
                            <p class="total-inner-p text-end me-2">
                              {{ invoice?.description }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Invoice Logo -->

                    <!-- Invoice To -->
                    <div class="invoice-item invoice-item-two">
                      <div class="invoice-address">
                        <div class="invoice-to">
                          <p class="customer-text-one">Invoice From:</p>
                          <p class="invoice-details-two">
                            {{ user?.name }}
                          </p>
                          <p class="invoice-details-two">
                            {{ user?.email }}
                          </p>
                          <p class="invoice-details-two">
                            {{ user?.phone }}
                          </p>
                          <p class="invoice-details-two">
                            {{ user?.address }}
                          </p>
                          <p class="invoice-details-two">
                            {{ user?.state }}
                            {{ user?.country }}
                          </p>
                        </div>
                        <div>
                          <p class="customer-text-one">Invoice To:</p>
                          <p class="invoice-details-two">
                            {{ invoice?.customer?.name }}<br />
                            {{ invoice?.customer?.email }}<br />
                            {{ `${invoice?.customer?.country_code} ${invoice?.customer?.phone}`
                            }}<br />
                            {{ invoice?.customer?.address }}<br />
                            {{ invoice?.customer?.state }}
                            {{ invoice?.customer?.country }}
                          </p>
                        </div>
                        <div class="invoice-to">
                          <p class="invoice-details-two text-end">
                            Status<br />
                            <span
                              class="invoice-status text-success"
                              v-if="
																invoice.status === 'paid' ||
																invoice.status === 'sent' ||
																invoice.status === 'viewed' ||
																invoice.status === 'accepted'
															"
                              >{{ invoice.status }}</span
                            >
                            <span
                              class="invoice-status text-warning"
                              v-else-if="
																invoice.status === 'draft' ||
																invoice.status === 'pending' ||
																invoice.status === 'unpaid' ||
																invoice.status === 'recurring'
															"
                              >{{ invoice.status }}</span
                            >
                            <span
                              class="invoice-status text-warning"
                              v-else-if="invoice.status === 'partially_paid'"
                              >Partially paid</span
                            >
                            <span
                              class="invoice-status text-danger"
                              v-else-if="
																invoice.status === 'expired' ||
																invoice.status === 'rejected' ||
																invoice.status === 'refunded' ||
																invoice.status === 'overdue'
															"
                              >{{ invoice.status }}</span
                            >
                          </p>
                          <p class="invoice-details-two text-end">
                            Date<br /><strong v-if="invoice.date">{{
															formatDateToDigits(invoice?.date)
                            }}</strong>
                          </p>
                          <p class="invoice-details-two text-end">
                            Due on<br /><strong v-if="invoice.due_date">{{
															formatDateToDigits(invoice?.due_date)
                            }}</strong>
                          </p>
                          <p class="invoice-details-two text-end">
                            Amount<br /><strong
                              >{{ invoice?.currency?.slice(0, 3) }}
                              {{
																addCurrencyComma(invoice?.total_amount)
                              }}</strong
                            >
                          </p>
                        </div>
                      </div>
                    </div>
                    <!-- /Invoice To -->

                    <!-- Invoice Item -->
                    <div class="invoice-item invoice-table-wrap">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="table-responsive2">
                            <table class="table table-center table-hover mb-0">
                              <thead class="thead-light">
                                <tr>
                                  <th class="table-data">#</th>
                                  <th class="table-data">Product / Service</th>
                                  <th class="table-data">Quantity</th>
                                  <th class="table-data">Price</th>
                                  <th class="table-data">Discount</th>
                                  <th class="text-end table-data">Amount</th>
                                </tr>
                              </thead>
                              <tbody v-if="invoice.items">
                                <tr
                                  v-for="(item, index) in invoice.items"
                                  :key="index"
                                >
                                  <td class="table-data">
                                    {{ index + 1 }}
                                  </td>
                                  <td class="table-data">{{ item.name }}</td>
                                  <td class="table-data">
                                    {{ item.quantity }}
                                  </td>
                                  <td class="table-data">
                                    {{ invoice?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(item.price) }}
                                  </td>
                                  <td class="table-data">
                                    {{ item.discount }}%
                                  </td>
                                  <td class="text-end table-data">
                                    {{ invoice?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(item.amount) }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /Invoice Item -->

                    <!-- Terms & Conditions -->
                    <div class="terms-conditions border-0">
                      <div class="row justify-content-end">
                        <div style="width: 48.5%; padding-right: 25px">
                          <div class="invoice-total-card">
                            <div class="invoice-total-box">
                              <div class="invoice-total-inner">
                                <p class="total-inner-p">
                                  Taxable Amount
                                  <span
                                    >{{ invoice?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(invoice.amount) }}</span
                                  >
                                </p>
                                <p class="total-inner-p">
                                  Discount<span
                                    >{{ invoice?.currency?.slice(0, 3) }}
                                    {{ totalProductDiscount?.toFixed(2) }}</span
                                  >
                                </p>
                                <p
                                  class="total-inner-p"
                                  v-if="invoice?.tax_enabled === 1"
                                >
                                  {{ `VAT(${invoice.tax_percentage}%)` }}
                                  <span
                                    >{{ invoice?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(vat) }}</span
                                  >
                                </p>
                                <p
                                  class="total-inner-p"
                                  v-for="(
																		discount, index
																	) in invoice?.more_discount"
                                  :key="index"
                                >
                                  {{ discount.description }}
                                  <span
                                    >- {{ invoice?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(discount.value) }}</span
                                  >
                                </p>
                                <p
                                  class="total-inner-p"
                                  v-for="(
																		charge, index
																	) in invoice?.additional_charges"
                                  :key="index"
                                >
                                  {{ charge.description }}
                                  <span
                                    >+ {{ invoice?.currency?.slice(0, 3) }}
                                    {{ addCurrencyComma(charge.value) }}
                                  </span>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Total -->
                    <div class="terms-conditions">
                      <div
                        style="display: flex; justify-content: space-between"
                      >
                        <div style="width: 54%">
                          <div>
                            <p class="total-inner-p">
                              Total Items :
                              {{ invoice?.items?.length }}
                            </p>
                          </div>
                        </div>
                        <div style="width: 47.8%; padding-right: 10px">
                          <div class="invoice-total-card">
                            <div class="invoice-total-box">
                              <div class="invoice-total-footer">
                                <h4
                                  class="total-amount"
                                  style="font-size: 20px"
                                >
                                  Total Amount
                                  <span
                                    >{{ invoice?.currency?.slice(0, 3) }}
                                    {{
																			addCurrencyComma(invoice?.total_amount)
                                    }}</span
                                  >
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Total -->
                    <div
                      v-if="invoice?.amount_paid != 0"
                      class="terms-conditions pt-4"
                    >
                      <div style="display: flex; justify-content: flex-end">
                        <div style="width: 46.5%; padding-right: 10px">
                          <div class="invoice-total-card">
                            <div class="invoice-total-box">
                              <div class="invoice-total-footer">
                                <h4
                                  class="total-amount2"
                                  style="font-size: 15px"
                                >
                                  Amount paid
                                  <span
                                    >{{ invoice?.currency?.slice(0, 3) }}
                                    {{
										                  addCurrencyComma(invoice?.amount_paid)
                                    }}</span
                                  >
                                </h4>
                                <h4
                                  class="total-amount2 mt-3"
                                  style="font-size: 15px"
                                >
                                  Balance
                                  <span
                                    >{{ invoice?.currency?.slice(0, 3) }}
                                    {{
										                  addCurrencyComma(invoice?.amount_due)
                                    }}</span
                                  >
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Total -->
                    <div class="terms-conditions">
                      <div style="display: flex; justify-content: start">
                        <div>
                          <div class="py-2">
                            <p class="total-inner-p">
                              Total Amount (in words):
                              <span
                                style="
																	margin-left: 2px;
																	color: black;
																	text-transform: capitalize;
																"
                                v-if="invoice?.total_amount"
                              >
                                {{
																	amountToWords(
																		invoice?.total_amount,
																		invoice?.currency
																	)
                                }}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Bank Details and Signature-->
                    <div
                      v-if="
												preferred_bank ||
												invoice.signature != null ||
												settings.signature != null
											"
                      class="terms-conditions"
                    >
                      <div
                        style="display: flex; justify-content: space-between"
                      >
                        <div>
                          <div v-if="preferred_bank">
                          <h1 class="bank-title total-amount">
                            Bank Information
                          </h1>
                            <p class="total-inner-p">
                              Bank's Name:
                              <span class="text-black">{{
																preferred_bank?.bank_name
                              }}</span>
                            </p>
                            <p class="total-inner-p">
                              Account Number:
                              <span class="text-black">{{
																preferred_bank?.account_number
                              }}</span>
                            </p>
                            <p class="total-inner-p">
                              Account Name:
                              <span class="text-black">{{
																preferred_bank?.account_name
                              }}</span>
                            </p>
                          </div>
                        </div>
                        <div class="text-end" v-if="invoice.signature != null">
                          <p
                            class="total-inner-p"
                            style="color: black; margin-bottom: 8px"
                          >
                            {{ invoice?.signatory_name }}
                          </p>
                          <img
                            style="max-width: 150px"
                            :src="invoice?.signature"
                            alt="Signature"
                          />
                        </div>
                        <div
                          class="text-end"
                          v-if="
														invoice.signature == null &&
														settings.signature != null
													"
                        >
                          <p
                            class="total-inner-p"
                            style="color: black; margin-bottom: 8px"
                          >
                            {{ settings?.signatory_name }}
                          </p>
                          <img
                            style="max-width: 150px"
                            :src="settings?.signature"
                            alt="Signature"
                          />
                        </div>
                      </div>
                    </div>

                    <!-- Terms and Conditions -->
                    <div v-if="invoice?.terms" class="terms-conditions">
                      <div style="display: flex">
                        <div class="text-start">
                          <p class="bank-title total-amount">
                            Terms and Conditions
                          </p>
                          <div
                            class="total-inner-e"
                            v-html="invoice.terms"
                          ></div>
                        </div>
                      </div>
                    </div>

                    <!-- Note -->
                    <div class="terms-conditions">
                      <div>
                        <div>
                          <div class="text-start">
                            <p class="bank-title total-amount">Notes</p>
                            <div
                              class="total-inner-e"
                              v-html="invoice.notes"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="content container-fluid" v-if="showPayment">
        <RecordedPayments :payments="invoice?.payments"/>
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>

  <!-- Delete Expense Modal -->
  <div class="modal custom-fade fade" id="delete_modal" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-body">
          <div class="form-header">
            <h3>
              <span v-if="selectedAction === 'delete'">Delete Invoice</span>
              <span v-if="selectedAction === 'send'">Send Invoice</span>
              <span v-if="selectedAction === 'sendinv'">Ready to send Invoice?</span>
              <span v-if="selectedAction === 'send-reminder'"
                >Send Reminder</span
              >
              <span v-if="selectedAction === 'duplicate'"
                >Duplicate Invoice</span
              >
              <span v-if="selectedAction === 'refund'">Refund Invoice</span>
              <span v-if="selectedAction === 'accept'">Accept Invoice</span>
              <span v-if="selectedAction === 'download'">Download Invoice</span>
            </h3>
            <p v-if="selectedItem">
              Are you sure want to
              <span v-if="selectedAction === 'delete'">delete</span>
              <span v-if="selectedAction === 'send' || selectedAction === 'sendinv'">send</span>
              <span v-if="selectedAction === 'send-reminder'"
                >send Reminder for</span
              >
              <span v-if="selectedAction === 'duplicate'">duplicate</span>
              <span v-if="selectedAction === 'refund'">refund</span>
              <span v-if="selectedAction === 'accept'">accept</span>
              <span v-if="selectedAction === 'download'">download</span>
              <span class="fw-semibold ms-1">{{
								selectedItem.customer.name
              }}</span>
              Invoice?
            </p>
          </div>
          <div class="modal-btn delete-action">
            <div class="row d-flex flex-column align-items-center">
              <div class="col-6 mb-2">
                <button
                  v-if="selectedAction === 'delete'"
                  @click="deleteInvoice"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Delete</span>
                  <span v-if="isLoading">Deleting...</span>
                </button>
                <button
                  v-if="selectedAction === 'send' || selectedAction === 'sendinv'"
                  @click="sendInvoice"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Send</span>
                  <span v-if="isLoading">Sending...</span>
                </button>
                <button
                  v-if="selectedAction === 'send-reminder'"
                  @click="sendReminder"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Send</span>
                  <span v-if="isLoading">Sending...</span>
                </button>
                <button
                  v-if="selectedAction === 'refund'"
                  @click="markAs('refunded')"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Refund</span>
                  <span v-if="isLoading">Refunding...</span>
                </button>
                <button
                  v-if="selectedAction === 'accept'"
                  @click="markAs('accepted')"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Accept</span>
                  <span v-if="isLoading">Accepting...</span>
                </button>
                <button
                  v-if="selectedAction === 'duplicate'"
                  @click="duplicateInvoices"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Duplicate</span>
                  <span v-if="isLoading">Duplicating...</span>
                </button>
                <button
                  v-if="selectedAction === 'download'"
                  @click="downloadInvoice"
                  class="w-100 btn btn-primary"
                  :disabled="isLoading"
                >
                  <span
                    v-if="isLoading"
                    class="spinner-border spinner-border-sm me-1"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  <span v-if="!isLoading">Download</span>
                  <span v-if="isLoading">Downloading...</span>
                </button>
              </div>
              <div class="col-6">
                <button
                  v-if="selectedAction === 'sendinv'"
                  type="submit"
                  data-bs-dismiss="modal"
                  class="w-100 btn btn-primary paid-cancel-btn"
                >
                  No, still editing.
                </button>
                <button
                  v-else
                  type="submit"
                  data-bs-dismiss="modal"
                  class="w-100 btn btn-primary paid-cancel-btn"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Delete Expense Modal -->

  <recordpayment
    :form="payment_form"
    :selectedItem="selectedItem"
    @closePaymentModal="closePaymentModal"
  />
  <!-- /Main Wrapper -->
</template>

<script setup>
import { computed, onMounted, ref, watch } from "vue";
import html2pdf from "html2pdf.js";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import {
	addCurrencyComma,
	amountToWords,
} from "@/assets/composables/currency";
import {
	formatDateToDigits,
	formatDateToDashDigits,
} from "@/assets/composables/date";
import { Modal } from "bootstrap";
import RecordedPayments from "../../../components/recorded-payments.vue";

const store = useStore();
const route = useRoute();
const router = useRouter();
const selectedItem = ref(null);
const selectedAction = ref(null);
const modalInstance = ref(null);
const paymentModal = ref(null);
const isLoading = ref(false);
const taxableAmount = ref(0);
const totalCharges = ref(0);
const totalDiscount = ref(0);
const totalAmount = ref(0);
const tax_percentage = ref(0);
const vat = ref(0);
const totalProductDiscount = ref(0);
const showPayment = ref(false)
const payment_form = ref({
	invoice_id: "",
	date: new Date(),
	method: "",
	amount: "",
  notify_client: false,
  notify_channels:[],
});

const resetPaymentForm = () => {
	payment_form.value = {
		invoice_id: "",
		date: new Date(),
		method: "",
		amount: "",
    notify_client: false,
    notify_channels:[],
	};
};

const openModal = (invoice, name) => {
	isLoading.value = false;
	selectedAction.value = name;
	selectedItem.value = invoice;
	modalInstance.value.show();
};
const closeModal = () => {
	modalInstance.value.hide();
};

const openPaymentModal = (invoice) => {
	isLoading.value = false;
	selectedItem.value = invoice;
	payment_form.value.invoice_id = invoice.id;
	payment_form.value.amount = invoice.amount_due;
	paymentModal.value.show();
};
const closePaymentModal = () => {
	paymentModal.value.hide();
	resetPaymentForm();
};

const calculateCharges = () => {
	let totalcharges = 0;
	totalCharges.value = 0;
	for (let i = 0; i < invoice.value?.additional_charges?.length; i++) {
		const item = invoice.value.additional_charges[i];
		totalcharges += parseInt(item.value);
	}
	totalCharges.value = totalcharges;
};
const calculateDiscount = () => {
	let totaldiscount = 0;
	totalDiscount.value = 0;
	for (let i = 0; i < invoice.value?.more_discount?.length; i++) {
		const item = invoice.value.more_discount[i];
		totaldiscount += parseInt(item.value);
	}
	totalDiscount.value = totaldiscount;
};
const calculateTotalAmount = () => {
	// Caalculate Total amount
	let totalproductamount = 0;
	let totalproductdiscount = 0;
	let totalamount = 0;
	for (let i = 0; i < invoice.value?.items?.length; i++) {
		const item = invoice.value.items[i];
		totalproductamount += item.amount;
		totalproductdiscount += (item.discount / 100) * item.amount;
	}
	taxableAmount.value = totalproductamount;
	totalProductDiscount.value = totalproductdiscount;
	calculateCharges();
	calculateDiscount();
	let T1 = totalproductamount + totalCharges.value;
	let T2 = totalproductdiscount + totalDiscount.value;
	totalamount = T1 - T2;
	// Calculate Tax
	if (invoice.value.tax_enabled === 1) {
		vat.value = (tax_percentage.value * totalamount) / 100;
		totalAmount.value = totalamount + vat.value;
	} else {
		totalAmount.value = totalamount;
	}
};

const getInvoice = async () => {
	await store
		.dispatch("invoices/getInvoice", route.params.id)
		.then(() => {
      tax_percentage.value = invoice.value.tax_percentage;
		})
		.then(() => {
			calculateTotalAmount();
    }).then(() => {
      if (invoice.value.status === 'draft') {
        console.log(invoice.value.status)
        openModal(invoice.value, 'sendinv')
      }
    })
};

const user = computed(() => {
	return store.getters["auth/user"];
});
const invoice = computed(() => {
	return store.getters["invoices/invoice"];
});

const settings = computed(() => {
	return store.getters["settings/settings"];
});
const preferred_bank = computed(() => {
	return store.getters["settings/preferred_bank"];
});

const getPreferredBank = () => {
	store.dispatch("settings/getPreferredBank");
};
const getSettings = () => {
	store.dispatch("settings/getSettings").then(() => {
		getPreferredBank();
	});
};
watch(settings,()=>{
  showPayment.value = settings.value.payment_history_on_invoice_page
})

watch(invoice,(newVal)=>{
  if (newVal) { 
  localStorage.setItem('selectedCurrency', newVal.currency)
  }
})
const downloadInvoice = async () => {
	isLoading.value = true;
	let screenwidth = window.screen.width;
	const element = document.getElementById("invoice");
	if (screenwidth <= 960) {
		element.style.display = "block";
	}
	const options = {
		filename: `${invoice.value.invoice_id}.pdf`,
		image: { type: "jpeg", quality: 0.98 },
		html2canvas: {
			dpi: 192,
			letterRendering: true,
			allowTaint: true,
			useCORS: true,
			logging: true,
		},
		jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
	};

	const uploadbtn = document.getElementsByClassName(
		"upload-logo"
	);
	const invoicedetailstwo = document.getElementsByClassName(
		"invoice-details-two"
	);
	const customertextone =
		document.getElementsByClassName("customer-text-one");
	const totalinnerp = document.getElementsByClassName("total-inner-p");
	const mobiledes = document.getElementsByClassName("descrip");
	const totalinnere = document.getElementsByClassName("total-inner-e");
	const totalamount = document.getElementsByClassName("total-amount");
	const totalamount2 = document.getElementsByClassName("total-amount2");
	const tabledata = document.getElementsByClassName("table-data");
	const invoicehead = document.getElementsByClassName("invoice-head");
	for (let i = 0; i < uploadbtn.length; i++) {
		uploadbtn[i].style.display = "none";
	}
	for (let i = 0; i < invoicedetailstwo.length; i++) {
		invoicedetailstwo[i].style.fontSize = "12px";
	}
	for (let i = 0; i < customertextone.length; i++) {
		customertextone[i].style.fontSize = "12px";
	}
	for (let i = 0; i < totalinnerp.length; i++) {
		totalinnerp[i].style.fontSize = "12px";
	}
	for (let i = 0; i < mobiledes.length; i++) {
		mobiledes[i].style.width = "col-4";
	}
	for (let i = 0; i < totalamount.length; i++) {
		totalamount[i].style.fontSize = "14px";
	}
	for (let i = 0; i < totalamount2.length; i++) {
		totalamount2[i].style.fontSize = "14px";
	}
	for (let i = 0; i < tabledata.length; i++) {
		tabledata[i].style.fontSize = "12px";
	}
	for (let i = 0; i < invoicehead.length; i++) {
		invoicehead[i].style.fontSize = "22px";
	}
	for (let i = 0; i < totalinnere.length; i++) {
		totalinnere[i].fontSize = "12px";
	}
	await html2pdf()
		.set(options)
		.from(element)
		.save()
    .then(() => {
      for (let i = 0; i < uploadbtn.length; i++) {
        uploadbtn[i].style.display = "block";
        uploadbtn[i].style.width = "fit-content";
      }
			for (let i = 0; i < invoicedetailstwo.length; i++) {
				invoicedetailstwo[i].style.fontSize = "14px";
			}
			for (let i = 0; i < customertextone.length; i++) {
				customertextone[i].style.fontSize = "14px";
			}
			for (let i = 0; i < totalinnerp.length; i++) {
				totalinnerp[i].style.fontSize = "14px";
			}
			for (let i = 0; i < totalamount.length; i++) {
				totalamount[i].style.fontSize = "20px";
			}
			for (let i = 0; i < totalamount2.length; i++) {
				totalamount2[i].style.fontSize = "15px";
			}
			for (let i = 0; i < tabledata.length; i++) {
				tabledata[i].style.fontSize = "14px";
			}
			for (let i = 0; i < invoicehead.length; i++) {
				invoicehead[i].style.fontSize = "26px";
			}
			for (let i = 0; i < totalinnere.length; i++) {
				totalinnere[i].fontSize = "14px";
			}
			if (screenwidth <= 960) {
				element.style.display = "none";
			}
			closeModal();
			isLoading.value = false;
		});
};

const duplicateInvoices = () => {
	isLoading.value = true;
	store
		.dispatch("invoices/duplicateInvoices", selectedItem.value.id)
		.then(() => {
			isLoading.value = false;
			closeModal();
			// getInvoices();
		})
		.catch(() => {
			isLoading.value = false;
			closeModal();
		});
};

const sendInvoice = () => {
	isLoading.value = true;
	store
		.dispatch("invoices/sendInvoice", selectedItem.value.id)
		.then(() => {
			isLoading.value = false;
			closeModal();
			getInvoice();
		})
		.catch(() => {
			isLoading.value = false;
			closeModal();
		});
};
const sendReminder = () => {
	isLoading.value = true;
	store
		.dispatch("invoices/sendReminder", selectedItem.value.id)
		.then(() => {
			isLoading.value = false;
			closeModal();
		})
		.catch(() => {
			isLoading.value = false;
			closeModal();
		});
};



const deleteInvoice = () => {
	isLoading.value = true;
	store
		.dispatch("invoices/deleteInvoice", selectedItem.value.id)
		.then(() => {
			isLoading.value = false;
			closeModal();
			router.push("/invoices");
		})
		.catch(() => {
			isLoading.value = false;
			closeModal();
		});
};

const markAs = (action) => {
	isLoading.value = true;
	let data = {
		id: selectedItem.value.id,
		payload: {
			status: action,
		},
	};

	store
		.dispatch("invoices/markAs", data)
		.then(() => {
			isLoading.value = false;
			closeModal();
			getInvoice();
		})
		.catch(() => {
			isLoading.value = false;
			closeModal();
		});
};



onMounted(async() => {
	getSettings();
	getInvoice();
	// Initiate modal
	modalInstance.value = new Modal(document.getElementById("delete_modal"), {
		backdrop: "static",
		keyboard: false,
	});

	paymentModal.value = new Modal(document.getElementById("payment_modal"), {
		backdrop: "static",
		keyboard: false,
	});
});
</script>

<style>
.d-invoice {
	display: block;
}
.new_class {
	font-size: 12px;
}
</style>
